import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { EqValidator } from '../../interfaces';
import { EqFormService } from '../eqform.service';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
const Material = [
  MatInputModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
];
@Component({
  selector: 'eq-base',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './eq-base.component.html',
  styleUrl: './eq-base.component.scss',
})
export class EqBaseComponent implements OnInit, OnDestroy {
  controlName: any;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() appearance: any = 'outline';
  @Input() header: any = '';
  @Input() headerSuccessText: string = '';
  @Input() name: string = '';
  @Input() icon: string = '';
  @Input() iconUrl: string = '';
  @Input() isDisable: boolean = false;
  @Input() readonly: boolean = false;
  @Input() checked: boolean = false;
  @Input() isForgotPassword: boolean = false;
  @Input() useAsFilter: boolean = false;
  // Form should be passed form parent component as input
  @Input() form!: FormGroup;
  @Input() validators: EqValidator[] = [];
  @Output() onChange = new EventEmitter<any>();
  @Output('onBlur') onBlur = new EventEmitter<string>();

  subscription! : Subscription;
  constructor(private readonly formService: EqFormService) {}

  ngOnChanges(changes: SimpleChanges): void {    
    if(changes['isDisable']){
      this.isDisable = changes['isDisable']?.currentValue
      if(this.isDisable) {
        this.form.get(this.name)?.disable();
      }else{
        this.form.get(this.name)?.enable();
      }
    }

    if (changes['checked']) {
      this.checked = changes['checked']?.currentValue;
    }
  }
  ngOnInit(): void {
    if (!this.form || !this.name) {
      const errMsg: string = !this.form
        ? 'form attribute is missing.'
        : 'name attribute is missing.';
      throw Error(errMsg);
    }
    this.formService.addFormControl(this.form, this.name, this.validators);
    this.controlName = this.form.controls[this.name];
    if(this.isDisable) this.form.get(this.name)?.disable();
    if(this.checked) this.form.get(this.name)?.setValue(this.checked);
    this.subscription = this.controlName?.valueChanges?.subscribe(
      (value: any) => {
        this.onChange.emit(value);
      }
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe()
    this.form.removeControl(this.name);
  }
  onBlurEvent(e: any) {
    this.onBlur.emit(e.target.value);
  }
  getErrorMessage() {
    return this.formService.getErrorMessage(
      this.form,
      this.name,
      this.validators
    );
  }
  hasError() {
    return this.formService.hasError(this.form, this.name);
  }
  isValid(){
    return this.formService.isValid(this.form, this.name);
  }

  isOptional(){
    if(this.validators?.length){
      return false
    }
    return true
  }

  isTouched(){
    return this.formService.isTouched(this.form, this.name);
  }
}
